import { SectionCard, REASON_LABEL, fmtPT } from "./shared";

export function SuppressionCampaigns({ data }) {
    const rows = data.campaigns || [];
    return (
        <SectionCard testId="suppression-campaigns" title="Prevented sends by campaign"
                     sub="Counted once per queued campaign text that was stopped before Twilio (send-time skips).">
            {rows.length === 0 ? (
                <div className="text-sm text-muted-foreground py-6 text-center" data-testid="campaigns-empty">
                    No campaign sends were prevented in this range.
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm" data-testid="campaigns-table">
                        <thead>
                            <tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground border-b">
                                <th className="py-2 pr-4">Campaign</th>
                                <th className="py-2 pr-4">Status</th>
                                <th className="py-2 pr-4">Breakdown</th>
                                <th className="py-2 pr-4">Last prevented</th>
                                <th className="py-2 text-right">Prevented</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((c) => (
                                <tr key={c.campaign_id || "none"} className="border-b last:border-0" data-testid={`campaign-row-${c.campaign_id}`}>
                                    <td className="py-2 pr-4 font-medium">{c.campaign_name}</td>
                                    <td className="py-2 pr-4 text-muted-foreground capitalize">{c.campaign_status || "—"}</td>
                                    <td className="py-2 pr-4 text-xs text-muted-foreground">
                                        {Object.entries(c.by_reason).map(([r, n]) => `${REASON_LABEL[r] || r}: ${n}`).join(" · ")}
                                    </td>
                                    <td className="py-2 pr-4 text-xs">{fmtPT(c.last_prevented_at)}</td>
                                    <td className="py-2 text-right font-semibold" data-testid={`campaign-total-${c.campaign_id}`}>{c.total}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {data.truncated ? (
                <div className="text-xs text-muted-foreground mt-2" data-testid="campaigns-truncated">
                    Showing the top {rows.length} of {data.campaign_count} campaigns. Narrow the date range to see the rest.
                </div>
            ) : null}
        </SectionCard>
    );
}
